import axios from '../request/http';

const Login = {
    getCode(params) {
        return axios.get("/admin/captcha");
    },
    login(params) {
        return axios.get("/admin/login", {params});
    },
    // 角色权限---路由数据
    roleInfo(params) {
        return axios.get("/admin/roles/info", {params});
    },
    // 首页统计数据
    homeInfoStatistics(params) {
        return axios.get("/admin/homeInfo/statistics", {params});
    },
    // 首页代办事项
    homeDealt(params) {
        return axios.get("/admin/homeInfo/todoList", {params});
    },
    // 首页用户基本信息
    homeUserInfo(params) {
        return axios.get("/admin/homeInfo/userBaseInfo", {params});
    },
    // 首页数据概念
    homeGeneralView(params) {
        return axios.get("/admin/homeInfo/generalView", {params});
    },
    // 首页操作日志
    homeJournal(params) {
        return axios.get("/admin/homeInfo/sysLogList", {params});
    },
      // 资金积分概览
  moneyIntegral(params) {
    return axios.get("/admin/homeInfo/get/moneyIntegral", {
      params
    });
  },
  // 资金看板数据
  moneyIntegralLog(params) {
    return axios.get("/admin/homeInfo/get/moneyIntegralLog", {
      params
    });
  },
  //获取资金积分概览信息Map
  MoneyIntegralMap(params) {
    return axios.get("/admin/homeInfo/MoneyIntegralMap", {
      params
    });
  },
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js